module.exports = __webpack_public_path__ + "static/media/pharmacy.04907f79.png";